module.exports = __webpack_public_path__ + "static/media/berlin.9e6aadd8.jpg";